<div class="row">
  <div class="col-lg-12 mb-4" *ngIf="!notIndividualView()">
    <div class="card">
      <div class="card-header"
           [style]="{backgroundColor: rgb(alarmTypeService.getColorByTypeId(alarmService.get(apiService.getParam('$alarm')).type))}">
        {{
          'app.' + alarmTypeService.get(alarmService.get(apiService.getParam('$alarm')).type).thymeleaf | translate
        }}:&nbsp;{{
          alarmService.get(apiService.getParam('$alarm')).code
        }}
      </div>
      <div class="card-body">
        <h5 class="card-title">
          {{ alarmService.get(apiService.getParam('$alarm')).locales[0].title }}
        </h5>
        <p class="card-text">
          {{ alarmService.get(apiService.getParam('$alarm')).locales[0].text }}
        </p>
      </div>
    </div>
  </div>
  <div class="col-lg-10">
    <div class="card overflow-hidden">
      <div class="p-2">
        <div class="row g-3">
          <div class="col-lg-4">
            <label>Project name</label>
            <h2>{{ getProjectName() }}</h2>
          </div>
          <div class="col-lg">
            <div class="form-floating">
              <select class="form-control form-control-sm form-select"
                      [(ngModel)]="settings.points" (change)="saveSettings()">
                <option [value]="10">10</option>
                <option [value]="30">30</option>
                <option [value]="60">60</option>
              </select>
              <label>Point count</label>
            </div>
          </div>
          <div class="col-lg">
            <div class="form-floating">
              <select class="form-control form-control-sm form-select"
                      [(ngModel)]="settings.interval" (change)="saveSettings()">
                <option [value]="60 * 1000">1min</option>
                <option [value]="10 * 60 * 1000">10min</option>
                <option [value]="30 * 60 * 1000">30min</option>
                <option [value]="60 * 60 * 1000">60min</option>
              </select>
              <label>Group by interval</label>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <canvas baseChart #lineChart
                  [type]="'line'"
                  [data]="lineChartData"
                  [options]="lineChartOptions"
                  (chartClick)="chartClicked($event)"></canvas>
        </div>
      </div>
      <div class="progress" style="height: 1px">
        <div class="progress-bar" role="progressbar" [style]="{ width: nextLoad + '%' }"></div>
      </div>
    </div>
  </div>
  <div class="col-lg-2">
    <div class="card p-2">
      <h2 class="text-center">Summary</h2>
      <canvas baseChart #doughnutChart
              [type]="'doughnut'"
              [data]="doughnutChartData"
              [options]="doughnutChartOptions"
              (chartClick)="chartClicked($event)"></canvas>
      <div *ngIf="notIndividualView()" class="mt-2">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="system"
                 [(ngModel)]="settings.alarmType.system" (change)="saveSettings()" disabled/>
          <label class="form-check-label" for="system">System</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="error"
                 [(ngModel)]="settings.alarmType.error" (change)="saveSettings()"/>
          <label class="form-check-label" for="error">Error</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="warning"
                 [(ngModel)]="settings.alarmType.warning" (change)="saveSettings()"/>
          <label class="form-check-label" for="warning">Warning</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="info"
                 [(ngModel)]="settings.alarmType.info" (change)="saveSettings()"/>
          <label class="form-check-label" for="info">Info</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="success"
                 [(ngModel)]="settings.alarmType.success" (change)="saveSettings()"/>
          <label class="form-check-label" for="success">Success</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="timing"
                 [(ngModel)]="settings.alarmType.timing" (change)="saveSettings()"/>
          <label class="form-check-label" for="timing">Timing</label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 mt-4">
    <div class="card overflow-hidden">
      <table class="table table-hover table-borderless mb-0" *ngIf="!notIndividualView()">
        <thead>
        <tr>
          <th scope="col" class="w-auto">#</th>
          <th scope="col" class="w-auto">Source</th>
          <th scope="col" class="w-auto">Occurred date</th>
          <th scope="col" class="w-auto">Count</th>
          <th scope="col" class="w-50">Properties</th>
          <th scope="col" class="w-auto">Stack</th>
        </tr>
        </thead>
        <tbody *ngFor="let detail of (this.stats[0] || { details:[] }).details; index as i"
               [style]="{ backgroundColor: getDetailColor(detail) }">
        <tr>
          <th scope="row">{{ i + 1 }}</th>
          <td>{{ detail.source }}</td>
          <td>{{ detail.happened | date:'MM-dd-yyyy hh:mm:ss' }}</td>
          <td>{{ detail.count }}</td>
          <td>
            <div class="overflow-auto">
              <div *ngIf="detail.ip">IP={{ detail.ip }}</div>
              <div *ngIf="detail.cause">Cause={{ detail.cause }}</div>
              <hr *ngIf="(detail.ip || detail.cause) && detail.attributes.length > 0" class="my-0"/>
              <div *ngFor="let attr of detail.attributes">{{ attr.key }}={{ attr.value }}</div>
            </div>
          </td>
          <td>
            <a data-bs-toggle="collapse" href="#stack{{ detail.id }}"
               role="button" aria-expanded="false">Show stacktrace</a>
            <br/>
            <a href="/dashboard?$stat={{ detail.id }}">Share</a>
          </td>
        </tr>
        <tr id="stack{{ detail.id }}" class="collapse">
          <td colspan="8">
            <div class="card card-body">
              <div *ngFor="let stack of detail.stacks">
                <div>{{ stack.message }}</div>
                <div *ngFor="let el of stack.elements">&emsp;{{ el }}</div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-hover mb-0" *ngIf="notIndividualView()">
        <thead>
        <tr>
          <th scope="col">Color</th>
          <th scope="col">Alarm</th>
          <th scope="col">Type</th>
          <th scope="col">Last occurred date</th>
          <th scope="col">Occurred count</th>
          <th scope="col">Unique count</th>
          <th scope="col">Details</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let stat of getStats()">
          <td [style]="{backgroundColor: rgb(alarmTypeService.getColorByTypeId(alarmService.get(stat.alarmId).type))}"
              (click)="setShow(stat)"></td>
          <td>{{ alarmService.get(stat.alarmId).code }}</td>
          <td>{{ 'app.' + alarmTypeService.get(alarmService.get(stat.alarmId).type).thymeleaf | translate }}</td>
          <td>{{ stat.lastOccurred | date:'MM-dd-yyyy hh:mm:ss' }}</td>
          <td>{{ stat.count }}</td>
          <td>{{ stat.unique.length }}</td>
          <td><a target="_blank" href="/dashboard?$alarm={{stat.alarmId}}">details</a></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
